import toast from "react-hot-toast";
type ApiRequestParams = {
    payload?: any | undefined;
    requestFunction: any;
    onSuccess: (response: any) => void;
    onError: (error: any) => void;
    onFinally?: () => void;
  };
  

  // await handleApiRequest({
  //   payload: transformedData,
  //   requestFunction: submitApplication,
  //   onSuccess: () => {
  //     toast.success("Application submitted successfully!");
  //     navigate("/dashboard")
  //   },
  //   onError: (err) => {
  //     const error = err as {
  //       data?: { errorSource?: { path?: string; message: string }[] };
  //     };

  //     if (error?.data) {
  //       error?.data?.errorSource?.forEach((item) => {
  //         if (item.path) {
  //           const formattedMessage = `${item.path} is ${item.message}`;
  //           console.log(formattedMessage);
  //           toast.error(formattedMessage);
  //         } else {
  //           console.log(item.message);
  //           toast.error(item.message);
  //         }
  //       });
  //     }
     
  //   },
  // });


  export const handleApiRequest = async ({
    payload,
    requestFunction,
    onSuccess,
    onError,
    onFinally = () => {},
  }: ApiRequestParams) => {
    try {
      const response = await requestFunction(payload).unwrap();
      if (response.success) {
        onSuccess(response);
      } else {
        toast.error(response.message || "Request failed.");
      }
    } catch (err: any) {
      onError(err);
    } finally {
      onFinally();
    }
  };
  